<template>
  <!--全部订阅记录-->
  <div id="myAllSuCriberList">
    <div>
      <div class="allDl m_t_20">
        <dl class="allDl_width20 allDl_span60">
          <dd>
            <span>订阅名称:</span>
            <div>
              <input v-model="serchData.Name" type="text" class="allInput"/>
            </div>
          </dd>
          <dd>
            <span>宽表名称:</span>
            <div>
              <allSelect v-model="serchData.TableId" :chooseData="myWideTableNameList" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
              </allSelect>
            </div>
          </dd>
          <dd>
            <span>订阅人:</span>
            <div>
              <allSelect v-model="serchData.Email" :chooseData="myAllUserList" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
              </allSelect>
            </div>
          </dd>
          <dd>
            <span>状态:</span>
            <div>
              <allSelect v-model="serchData.Status" :chooseData="$commonJs.subscriberTypeList" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
              </allSelect>
            </div>
          </dd>
          <dt style="width: auto;">
            <button @click="allSerch()" class="suerButton"><i class="icon iconfont iconsousuo" style="font-size: 14px"></i><span class="m_l_5">搜索</span></button>
          </dt>
        </dl>
      </div>
      <div style="max-height: calc(100vh - 270px);overflow: auto">
        <table class="allTable" cellspacing="0">
          <thead>
          <tr>
            <th>订阅名称</th>
            <th>宽表名称</th>
            <th>订阅人</th>
            <th>状态</th>
            <th>创建时间</th>
            <th>最近修改时间</th>
            <th>最近修改人</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myAllList">
            <td style="max-width: 120px" class="NoWrap" :title="item.name">{{ item.name }}</td>
            <td>{{ item.tableName}}</td>
            <td>{{item.creatorId}}</td>
            <td :style="{'color':parseInt(item.status) === 1 ? '#00B828' : '#EB0000'}">●&nbsp;{{parseInt(item.status) === 1 ? '运行' : '停止'}}</td>
            <td>{{ item.createTime }}</td>
            <td>{{ item.lastModifyTime }}</td>
            <td>{{ item.lastModifier }}</td>
            <td class="colorYellowF36A20" width="80">
              <div class="d_flex">
                <span @click="allVideo(item)" class="c_p">查看</span>
                <span v-if="parseInt(item.status) === 2" @click="allRunToDelete(true, item)" class="c_p">运行</span>
                <span v-if="parseInt(item.status) === 1" @click="allRunToDelete(false, item)" class="c_p">停止</span>
                <span @click="allDelt(item)" class="colorDele c_p">删除</span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <page :totalCount="totalCount" v-if="totalPage !== 0" v-on:on-getList="getAllList($event)" :totalPage="totalPage" :page="page" :numPage="1"></page>
    </div>
    <model v-if="showModel" :title="'订阅'" :minWidth="'60%'" :onButton="1" v-on:on-cancel="showModel = false" v-on:on-confirm="confirmSuCriber">
      <div class="pd_10_20">
        <div class="dnlUl" style="max-height: 70vh;overflow: auto">
          <ul>
            <li>
              <span style="vertical-align: top">已选参数：</span>
              <div>
                <div class="dnlUl_par">
                  <p :key="index" v-for="(item, index) in subscriptionData.parameterJsonList">{{ item }}</p>
                </div>
              </div>
            </li>
            <li v-if="parseInt(isGenre) === 1">
              <span>订阅名称:</span>
              <div>
                <input v-model="subscriptionData.subscribeName" type="text"  class="allInput" style="width: calc(100% - 12px)"/>
              </div>
            </li>
            <li>
              <span style="vertical-align: top;margin-top: 5px">邮箱地址：</span>
              <div>
                <section class="dnlUl_emlS">
                  <input @input="seltEmail()" v-model="serchEamil" type="text" placeholder="请输入..."/>
                  <div v-if="serchEamil !== ''">
                    <div v-if="allEmailList.length === 0">未找到任何结果</div>
                    <p @click="pickEmail(item, 1)" class="NoWrap" :key="index" v-for="(item, index) in allEmailList">{{ item }}</p>
                    <p @click="pickEmail('', 2)" class="NoWrap" v-if="allEmailList.length === 0">{{ serchEamil }}</p>
                  </div>
                </section>
                <div class="dnlUl_eml">
                  <div :key="index" v-for="(item, index) in subscriptionData.subscribeEmails">
                    <span class="m_r_10">{{ item }}</span>
                    <i @click="eraseEmail(index)" class="icon iconfont iconguanbi colorYellowF36A20"></i>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <span>邮箱标题:</span>
              <div>
                <input v-model="subscriptionData.subscribeTitle" type="text"  class="allInput" style="width: calc(100% - 12px)"/>
              </div>
            </li>
            <li>
              <span>正文：</span>
              <div>
                <textarea v-model="subscriptionData.subscribeBody" rows="5" class="allTextarea" style="width: calc(100% - 12px)"></textarea>
              </div>
            </li>
            <li>
              <span>文件类型：</span>
              <div class="v_m" style="width: 100px">
                <allSelect v-model="subscriptionData.fileType" :chooseData="subfileType" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
                </allSelect>
              </div>
            </li>
            <li v-if="parseInt(isGenre) === 1">
              <span>订阅周期：</span>
              <div>
                <input v-model="subscriptionData.uploadFrequency" value="EveryDay" type="radio" class="allRadio" id="mdRadio1" name="mdRadio"/>
                <label for="mdRadio1"></label><label for="mdRadio1"><span class="m_l_5 m_r_20">每天</span></label>
                <input v-model="subscriptionData.uploadFrequency" value="EveryWeek" type="radio" class="allRadio" id="mdRadio2" name="mdRadio"/>
                <label for="mdRadio2"></label><label for="mdRadio2"><span class="m_l_5 m_r_20">每周</span></label>
                <input v-model="subscriptionData.uploadFrequency" value="EveryMonth" type="radio" class="allRadio" id="mdRadio3" name="mdRadio"/>
                <label for="mdRadio3"></label><label for="mdRadio3"><span class="m_l_5">每月</span></label>
              </div>
            </li>
            <li v-if="parseInt(isGenre) === 1">
              <span style="margin-top: 7px">发送时间：</span>
              <div style="vertical-align: top">
                <!--每天-->
                <div v-if="subscriptionData.uploadFrequency === 'EveryDay'">
                  <div class="dis_line v_m" style="width: 60px">
                    <allSelect v-model="subScriTime.fisthours" :chooseData="$commonJs.returnHours(1)" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
                    </allSelect>
                  </div>
                  <div class="dis_line v_m t_c" style="width: 10px">:</div>
                  <div class="dis_line v_m" style="width: 60px">
                    <allSelect v-model="subScriTime.lastMin" :chooseData="$commonJs.returnHours(2)" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
                    </allSelect>
                  </div>
                </div>
                <!--每周-->
                <div v-if="subscriptionData.uploadFrequency === 'EveryWeek'">
                  <div class="dis_line v_m m_r_10" style="width: 100px">
                    <allSelect v-model="subScriTime.weekTime" :chooseData="weekList" :multiple="true" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
                    </allSelect>
                  </div>
                  <div class="dis_line v_m" style="width: 60px">
                    <allSelect v-model="subScriTime.weekHours" :chooseData="$commonJs.returnHours(1)" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
                    </allSelect>
                  </div>
                  <div class="dis_line v_m t_c" style="width: 10px">:</div>
                  <div class="dis_line v_m" style="width: 60px">
                    <allSelect v-model="subScriTime.weekMin" :chooseData="$commonJs.returnHours(2)" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
                    </allSelect>
                  </div>
                </div>
                <!--每月-->
                <div v-if="subscriptionData.uploadFrequency === 'EveryMonth'">
                  <div class="m_b_10">
                    <input v-model="subScriTime.isData" :value="1" type="radio" class="allRadio" id="muthRadio1"/>
                    <label for="muthRadio1"></label>
                    <div class="d_flex m_l_5" style="display: inline-flex;width: 270px" v-if="parseInt(subScriTime.isTwo) === 1">
                      <div>第</div>
                      <div>
                        <input v-model="subScriTime.fistDate" type="number" class="allInput" style="width: 21px" :disabled="parseInt(subScriTime.isData) === 2"/>
                      </div>
                      <div class="m_l_5">个工作日</div>
                      <div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect v-model="subScriTime.monHours" :chooseData="$commonJs.returnHours(1)" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'" :disabled="parseInt(subScriTime.isData) === 2">
                          </allSelect>
                        </div>
                        <div class="dis_line v_m t_c" style="width: 10px">:</div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect v-model="subScriTime.monMin" :chooseData="$commonJs.returnHours(2)" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'" :disabled="parseInt(subScriTime.isData) === 2">
                          </allSelect>
                        </div>
                      </div>
                      <div>
                        <i @click="seltWeek(2)" class="icon iconfont iconicon02 colorYellowF36A20" v-if="parseInt(subScriTime.isData) === 1"></i>
                      </div>
                    </div>
                    <div class="d_flex m_l_5" style="display: inline-flex;width: 430px" v-if="parseInt(subScriTime.isTwo) === 2">
                      <div>第</div>
                      <div>
                        <input v-model="subScriTime.fistDate" type="number" class="allInput" style="width: 21px" :disabled="parseInt(subScriTime.isData) === 2"/>
                      </div>
                      <div class="m_l_5">个工作日</div>
                      <div class="m_r_5 colorYellowF36A20">
                        <i @click="seltWeek(1)" class="icon iconfont iconguanbi" v-if="parseInt(subScriTime.isData) === 1"></i>
                        <span class="m_l_5">&</span>
                      </div>
                      <div>第</div>
                      <div>
                        <input v-model="subScriTime.lastDate" type="number" class="allInput" style="width: 21px" :disabled="parseInt(subScriTime.isData) === 2"/>
                      </div>
                      <div class="m_l_5">个工作日</div>
                      <div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect v-model="subScriTime.monHours" :chooseData="$commonJs.returnHours(1)" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'" :disabled="parseInt(subScriTime.isData) === 2">
                          </allSelect>
                        </div>
                        <div class="dis_line v_m t_c" style="width: 10px">:</div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect v-model="subScriTime.monMin" :chooseData="$commonJs.returnHours(2)" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'" :disabled="parseInt(subScriTime.isData) === 2">
                          </allSelect>
                        </div>
                      </div>
                      <div>
                        <i @click="seltWeek(1)" class="icon iconfont iconguanbi colorYellowF36A20" v-if="parseInt(subScriTime.isData) === 1"></i>
                      </div>
                    </div>
                  </div>
                  <div>
                    <input v-model="subScriTime.isData" :value="2" type="radio" class="allRadio" id="muthRadio2"/>
                    <label for="muthRadio2"></label>
                    <div class="d_flex m_l_5" style="display: inline-flex;width: 215px">
                      <div>第</div>
                      <div>
                        <input v-model="subScriTime.allData" type="number" class="allInput" style="width: 21px" :disabled="parseInt(subScriTime.isData) === 1"/>
                      </div>
                      <div class="m_l_5">天</div>
                      <div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect v-model="subScriTime.monHoursTwo" :chooseData="$commonJs.returnHours(1)" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'" :disabled="parseInt(subScriTime.isData) === 1">
                          </allSelect>
                        </div>
                        <div class="dis_line v_m t_c" style="width: 10px">:</div>
                        <div class="dis_line v_m" style="width: 60px">
                          <allSelect v-model="subScriTime.monMinTwo" :chooseData="$commonJs.returnHours(2)" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'" :disabled="parseInt(subScriTime.isData) === 1">
                          </allSelect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </model>
<!--    <model v-if="showModel" :title="'订阅'" :minWidth="'60%'" :onButton="0" v-on:on-cancel="showModel = false">-->
<!--      <div class="pd_10_20">-->
<!--        <div class="dnlUl">-->
<!--          <ul>-->
<!--            <li>-->
<!--              <span style="vertical-align: top">已选参数：</span>-->
<!--              <div>-->
<!--                <div class="dnlUl_par">-->
<!--                  <p :key="index" v-for="(item, index) in subscriptionData.parameterJsonList">{{ item }}</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </li>-->
<!--            <li>-->
<!--              <span style="vertical-align: top;margin-top: 5px">邮箱地址：</span>-->
<!--              <div>-->
<!--                &lt;!&ndash;<section class="dnlUl_emlS">&ndash;&gt;-->
<!--                &lt;!&ndash;  <input type="text" placeholder="请输入..."/>&ndash;&gt;-->
<!--                &lt;!&ndash;  <div>&ndash;&gt;-->
<!--                &lt;!&ndash;    <p>未找到任何结果</p>&ndash;&gt;-->
<!--                &lt;!&ndash;    <p class="NoWrap">1234@qq.com</p>&ndash;&gt;-->
<!--                &lt;!&ndash;    <p class="NoWrap">1234@qq.com</p>&ndash;&gt;-->
<!--                &lt;!&ndash;  </div>&ndash;&gt;-->
<!--                &lt;!&ndash;</section>&ndash;&gt;-->
<!--                <div class="dnlUl_eml">-->
<!--                  <div :key="index" v-for="(item, index) in subscriptionData.subscribeEmails">-->
<!--                    <span class="m_r_10">{{ item }}</span>-->
<!--                    &lt;!&ndash;<i class="icon iconfont iconguanbi colorYellowF36A20"></i>&ndash;&gt;-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </li>-->
<!--            <li>-->
<!--              <span>邮箱标题:</span>-->
<!--              <div>-->
<!--                <input v-model="subscriptionData.subscribeTitle" type="text"  class="allInput" style="width: calc(100% - 12px)" disabled/>-->
<!--              </div>-->
<!--            </li>-->
<!--            <li>-->
<!--              <span>正文：</span>-->
<!--              <div>-->
<!--                <textarea v-model="subscriptionData.subscribeBody" rows="5" class="allTextarea" style="width: calc(100% - 12px)" disabled></textarea>-->
<!--              </div>-->
<!--            </li>-->
<!--            <li>-->
<!--              <span>文件类型：</span>-->
<!--              <div>-->
<!--                <span>{{ parseInt(subscriptionData.fileType) === 1 ? 'excel' : 'csv'}}</span>-->
<!--              </div>-->
<!--            </li>-->
<!--            <li>-->
<!--              <span>订阅周期：</span>-->
<!--              <div>-->
<!--                <span>{{ returnWeek(subscriptionData.uploadFrequency) }}</span>-->
<!--              </div>-->
<!--            </li>-->
<!--            <li>-->
<!--              <span>发送时间：</span>-->
<!--              <div>-->
<!--                <span>{{ subscriptionData.sendTime }}</span>-->
<!--              </div>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </div>-->
<!--    </model>-->
  </div>
</template>

<script>
let timeOutEml
export default {
  name: 'myAllSuCriberList',
  data () {
    return {
      isGenre: 1,
      serchEamil: '',
      allEmailList: [],
      subScriTime: {
        weekTime: '',
        fisthours: '00',
        lastMin: '00',
        weekHours: '00',
        weekMin: '00',
        monHours: '00',
        monMin: '00',
        monHoursTwo: '00',
        monMinTwo: '00',
        fistDate: '',
        lastDate: '',
        allData: '',
        isData: 1,
        isTwo: 1
      },
      weekList: [
        {
          id: '',
          name: '全部'
        },
        {
          id: 1,
          name: '周一'
        },
        {
          id: 2,
          name: '周二'
        },
        {
          id: 3,
          name: '周三'
        },
        {
          id: 4,
          name: '周四'
        },
        {
          id: 5,
          name: '周五'
        },
        {
          id: 6,
          name: '周六'
        },
        {
          id: 7,
          name: '周日'
        }
      ],
      subfileType: [
        {
          id: 1,
          name: 'excel'
        },
        {
          id: 2,
          name: 'csv'
        }
      ],
      showModel: false,
      totalPage: 0,
      totalCount: 0,
      page: 1,
      serchData: {
        Name: '',
        TableId: 0,
        Status: 0,
        IsPersonal: false,
        Email: '',
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      postData: {
        Name: '',
        TableId: 0,
        Status: 0,
        IsPersonal: false,
        Email: '',
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      myAllList: [],
      myWideTableNameList: [
        {
          id: 0,
          name: '全部'
        }
      ],
      myAllUserList: [
        {
          id: 0,
          name: '全部'
        }
      ],
      subscriptionData: {
        id: 0,
        fileName: '',
        subscribeName: '',
        subscribeEmails: [], // 邮箱
        subscribeTitle: '', // 标题
        subscribeBody: '', // 正文
        parameterJson: '', // 已选参数
        parameterJsonList: [],
        tableId: this.formChildTableId,
        fileType: 1, // 文件类型 1 = excel, 2 = csv
        uploadFrequency: 'EveryDay', // EveryDay, EveryWeek, EveryMonth
        sendTime: ''
      },
      allWeek: [
        {
          id: 1,
          name: '周一'
        },
        {
          id: 2,
          name: '周二'
        },
        {
          id: 3,
          name: '周三'
        },
        {
          id: 4,
          name: '周四'
        },
        {
          id: 5,
          name: '周五'
        },
        {
          id: 6,
          name: '周六'
        },
        {
          id: 7,
          name: '周日'
        }
      ]
    }
  },
  created () {
    this.$commonJs.addLog('查看', '数据下载', '全部订阅记录', '')
    this.getAllUser()
    this.getWideTableNameList()
    this.getAllList(1)
  },
  methods: {
    // 根据搜索获取邮箱
    seltEmail () {
      clearTimeout(timeOutEml)
      timeOutEml = setTimeout(p => {
        this.getAllEmail()
      }, 1000)
    },
    pickEmail (item, type) {
      if (parseInt(type) === 1) {
        this.subscriptionData.subscribeEmails.push(item)
        this.allEmailList = []
        this.serchEamil = ''
      } else {
        if (this.$commonJs.returnDigit(this.serchEamil, 'email', '请输入正确的邮箱')) {
          this.serchEamil = ''
          return
        }
        this.subscriptionData.subscribeEmails.push(this.serchEamil)
        this.serchEamil = ''
      }
    },
    eraseEmail (index) {
      this.subscriptionData.subscribeEmails.splice(index, 1)
    },
    getAllEmail () {
      this.$axiox.get('/api/Role/SearchEmail?email=' + this.serchEamil, '', true).then(msg => {
        this.allEmailList = msg.data || []
      })
    },
    // 获取订阅人员
    getAllUser () {
      this.$axiox.get('/api/Download/GetSubscribeUsers').then(msg => {
        let list = msg.data || []
        for (let i = 0; i < list.length; i++) {
          if (list[i]) {
            let data = {
              id: list[i],
              name: list[i]
            }
            this.myAllUserList.push(data)
          }
        }
      })
    },
    // 获取宽表名称
    getWideTableNameList () {
      this.$axiox.get('/api/Download/GetDownloadTableList').then(msg => {
        let list = msg.data || []
        for (let i = 0; i < list.length; i++) {
          if (list[i]) {
            let data = {
              id: list[i].key,
              name: list[i].value
            }
            this.myWideTableNameList.push(data)
          }
        }
      })
    },
    allSerch () {
      this.postData = JSON.parse(JSON.stringify(this.serchData))
      this.getAllList(1)
    },
    getAllList (page) {
      let data = JSON.parse(JSON.stringify(this.postData))
      data.PageIndex = page
      let url = this.$commonJs.returnQuery('/api/Download/QuerySubscribe', data)
      this.$axiox.get(url).then(msg => {
        this.myAllList = msg.datas || []
        this.page = page
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    },
    allVideo (item) {
      this.subscriptionData = {
        id: 0,
        fileName: '',
        subscribeName: '',
        subscribeEmails: [], // 邮箱
        subscribeTitle: '', // 标题
        subscribeBody: '', // 正文
        parameterJson: '', // 已选参数
        parameterJsonList: [],
        tableId: this.formChildTableId,
        fileType: 1, // 文件类型 1 = excel, 2 = csv
        uploadFrequency: 'EveryDay', // EveryDay, EveryWeek, EveryMonth
        sendTime: ''
      }
      this.subScriTime = {
        weekTime: '',
        fisthours: '00',
        lastMin: '00',
        weekHours: '00',
        weekMin: '00',
        monHours: '00',
        monMin: '00',
        monHoursTwo: '00',
        monMinTwo: '00',
        fistDate: '',
        lastDate: '',
        allData: '',
        isData: 1,
        isTwo: 1
      }
      // this.showModel = true
      this.$axiox.get('/api/Download/SubscribeDetail?id=' + item.id).then(msg => {
        if (!msg.data) {
          return
        }
        this.showModel = true
        this.subscriptionData = msg.data
        this.subscriptionData.parameterJsonList = this.subscriptionData.parameterJson.split(',')
        if (this.subscriptionData.uploadFrequency === 'EveryWeek') {
          let fhIndex = this.subscriptionData.sendTime.lastIndexOf('/')
          let lastTime = this.subscriptionData.sendTime.substring(fhIndex + 1, this.subscriptionData.sendTime.length)
          let wek = this.subscriptionData.sendTime.substring(0, fhIndex).split(',').sort((a, b) => { return a - b })
          // this.subScriTime.weekTime = wek.length === 7 ? '' : wek
          let wekList = wek.length === 7 ? [] : wek
          this.subScriTime.weekTime = wekList.join(',')
          let timeIndex = lastTime.lastIndexOf(':')
          this.subScriTime.weekHours = lastTime.substring(0, timeIndex).toString()
          this.subScriTime.weekMin = lastTime.substring(timeIndex + 1, lastTime.length).toString()
        } else if (this.subscriptionData.uploadFrequency === 'EveryMonth') {
          let tmIndex = this.subscriptionData.sendTime.lastIndexOf('/')
          let newTime = this.subscriptionData.sendTime.substring(tmIndex + 1, this.subscriptionData.sendTime.length)
          let newTmIndex = newTime.lastIndexOf(':')
          if (this.subscriptionData.sendTime.indexOf('工作日') > 0) {
            this.subScriTime.isData = 1
            let dayIndex = this.subscriptionData.sendTime.lastIndexOf('个')
            let newDay = this.subscriptionData.sendTime.substring(0, dayIndex).split(',')
            this.subScriTime.isTwo = newDay.length
            this.subScriTime.fistDate = newDay[0]
            this.subScriTime.lastDate = newDay[1] || ''
            this.subScriTime.monHours = newTime.substring(0, newTmIndex).toString()
            this.subScriTime.monMin = newTime.substring(newTmIndex + 1, newTime.length).toString()
          } else if (this.subscriptionData.sendTime.indexOf('天') > 0) {
            this.subScriTime.isData = 2
            let dayIndex = this.subscriptionData.sendTime.lastIndexOf('天')
            this.subScriTime.allData = this.subscriptionData.sendTime.substring(0, dayIndex)
            this.subScriTime.monHoursTwo = newTime.substring(0, newTmIndex).toString()
            this.subScriTime.monMinTwo = newTime.substring(newTmIndex + 1, newTime.length).toString()
          }
        } else if (this.subscriptionData.uploadFrequency === 'EveryDay') {
          let valIndex = this.subscriptionData.sendTime.lastIndexOf(':')
          this.subScriTime.fisthours = this.subscriptionData.sendTime.substring(0, valIndex).toString()
          this.subScriTime.lastMin = this.subscriptionData.sendTime.substring(valIndex + 1, this.subscriptionData.sendTime.length).toString()
        }
      })
    },
    seltWeek (type) {
      this.subScriTime.isTwo = type
      this.subScriTime.fistDate = ''
      this.subScriTime.lastDate = ''
    },
    confirmSuCriber () {
      if (this.subscriptionData.subscribeName === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请输入订阅名称',
          stayTime: 5
        })
        return
      }
      if (this.subscriptionData.subscribeEmails.length === 0) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择邮箱地址',
          stayTime: 5
        })
        return
      }
      if (this.subscriptionData.subscribeTitle === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择输入邮箱标题',
          stayTime: 5
        })
        return
      }
      if (this.subscriptionData.subscribeBody === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择输入正文',
          stayTime: 5
        })
        return
      }
      if (parseInt(this.isGenre) === 1) {
        if (this.subscriptionData.uploadFrequency === 'EveryDay') {
          this.subscriptionData.sendTime = this.subScriTime.fisthours + ':' + this.subScriTime.lastMin
        } else if (this.subscriptionData.uploadFrequency === 'EveryWeek') {
          let watt = this.subScriTime.weekTime !== '' ? this.subScriTime.weekTime : '1,2,3,4,5,6,7'
          this.subscriptionData.sendTime = watt + '/' + this.subScriTime.weekHours + ':' + this.subScriTime.weekMin
        } else if (this.subscriptionData.uploadFrequency === 'EveryMonth') {
          if (parseInt(this.subScriTime.isData) === 1) {
            let wday = this.subScriTime.lastDate !== '' ? this.subScriTime.fistDate + ',' + this.subScriTime.lastDate : this.subScriTime.fistDate
            this.subscriptionData.sendTime = wday + '个工作日/' + this.subScriTime.monHours + ':' + this.subScriTime.monMin
          } else {
            this.subscriptionData.sendTime = this.subScriTime.allData + '天/' + this.subScriTime.monHoursTwo + ':' + this.subScriTime.monMinTwo
          }
        }
        // this.subscriptionData.fileName = this.pickleName
        this.$axiox.post('/api/Download/EditSubscribe', this.subscriptionData).then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '编辑订阅成功',
            stayTime: 5
          })
          this.showModel = false
          this.getAllList(this.page)
        })
      } else {
        // console.log(this.subscriptionData)
        let data = {
          sendName: '',
          sendTitle: this.subscriptionData.subscribeTitle,
          sendBody: this.subscriptionData.subscribeBody,
          sendEmails: JSON.parse(JSON.stringify(this.subscriptionData.subscribeEmails)),
          parameterJson: this.subscriptionData.parameterJson,
          tableId: this.subscriptionData.tableId,
          fileType: this.subscriptionData.fileType,
          parameterJsonEn: JSON.parse(JSON.stringify(this.subscriptionData.parameterJsonEn)),
          fileName: this.subscriptionData.pickleName
        }
        this.$axiox.post('/api/Download/EditSendData', data).then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '发送成功',
            stayTime: 5
          })
          this.showModel3 = false
        })
      }
    },
    returnWeek (type) {
      switch (type) {
        case 'EveryDay':
          return '每天'
        case 'EveryWeek':
          return '每周'
        case 'EveryMonth':
          return '每月'
      }
      return ''
    },
    allRunToDelete (type, item) {
      let tab = type ? '运行' : '停止'
      this.$commonJs.doubleComfirm({
        content: '是否' + tab + '该订阅？',
        successFun: msg => {
          this.$axiox.get('/api/Download/EnableSubscribe?id=' + item.id + '&isEnable=' + type).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: type ? '运行' : '停止' + '成功',
              stayTime: 5
            })
            this.getAllList(this.page)
          })
        },
        errorFun: msg => {
        }
      })
    },
    allDelt (item) {
      this.$commonJs.doubleComfirm({
        content: '是否删除该订阅？',
        successFun: msg => {
          this.$axiox.get('/api/Download/DeleteSubscribe?id=' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getAllList(this.page)
          })
        },
        errorFun: msg => {
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/myDnload/myAllSuCriberList.vue